import * as _ from 'lodash';


export const getRowStatusColor = (
  statusColorMap: any,
  row: any,
  isVersion2: boolean = false,
) => {
  if (row.hideStatus) { return ''; }
  if (_.has(row, 'valid')) {
    return row.valid ? 'green' : 'red';
  } else if (statusColorMap) {
    return statusColorMap[row.status];
  } else {
    switch (row.status) {
      case 1: // 'in-review'/'unassigned':
        return isVersion2 ? 'selectiveYellow' : 'yellow';
      case 0: // 'in-draft':
      case 100: // 'changed':
      case 3: // 'not uploaded' (for DAM):
        return 'red';
      case 2: // 'approved'/'assigned':
        return 'green';
      case 5: // 'import-accepted'
        return 'astronaut';
      case 101: // 'new':
        return 'green';
      case 102: // 'unchanged':
      case 103: // 'altered':
        return 'darkblue';
      case 4: // 'import-uploaded':
        return 'cyan';
      default:
        return 'green';
    }
  }
};
